import React, {
  useEffect,
  useState,
  useRef,
  useCallback,
  useContext,
} from 'react';

import { CiFilter } from 'react-icons/ci';
import { FiChevronDown } from 'react-icons/fi';
import { CardFiltersContext } from './context/filters-context';

import MainFilters from './components/MainFilters';
import { hasSelected } from './context/utils';

export default function CardFilters({ headerState, setHeaderState }) {
  const { state, dispatch, date } = useContext(CardFiltersContext);
  console.log(state, 'redering from herer');
  const ref = useRef(null);
  const [dropdown, setDropdown] = useState(false);

  useEffect(() => {
    const handler = (event) => {
      if (dropdown && ref.current && !ref.current.contains(event.target)) {
        setDropdown(false);
      }
    };
    document.addEventListener('mousedown', handler);
    document.addEventListener('touchstart', handler);
    return () => {
      // Cleanup the event listener
      document.removeEventListener('mousedown', handler);
      document.removeEventListener('touchstart', handler);
    };
  }, [dropdown]);

  const toggleDropDown = useCallback(
    () => setDropdown((oldState) => !oldState),
    []
  );

  const depthLevel = 1;
  function formatObject(inputObj) {
    const formattedKey = inputObj.title.toUpperCase(); // Convert title to uppercase
    const selectedList = inputObj.selectedList;

    // Extract the key-value pairs from the selectedList
    const formattedList = Object.entries(selectedList).map(([name, _id]) => ({
      _id,
      name,
    }));

    // Return the object in the desired format
    return {
      [formattedKey]: formattedList,
    };
  }

  useEffect(() => {
    let resultForParent = {};
    state.forEach((state) => {
      resultForParent = { ...resultForParent, ...formatObject(state) };
    });

    // setHeaderState(resultForParent, date.dateState);
  }, [
    ...state.flatMap((item) => Object.entries(item.selectedList).length),
    date.dateState,
  ]);
  useEffect(() => {
    dispatch[0]({ type: 'REMOVE_SELECTED' });
  }, []);

  return (
    <div className="dashboardFilters--dropdown">
      <button
        aria-expanded={dropdown.toString()}
        onClick={toggleDropDown}
        className="dashboardFilters--dropdown--toggle"
      >
        <span
          className={`flex p-1 ${hasSelected(state) ? "relative after:content-[''] after:absolute after:top-[-3px] after:right-[-0.2rem] after:w-2 after:h-2 after:bg-[#2D9F75] after:rounded-full" : ''}  `}
        >
          <CiFilter />
          <FiChevronDown className="ml-1" />
        </span>
      </button>
      <MainFilters
        dropdown={dropdown}
        depthLevel={depthLevel}
        toggleDropDown={toggleDropDown}
        handleDateSelection={date.handleDateSelection}
      />
    </div>
  );
}
